import script from "./TablePaginated.vue?vue&type=script&lang=ts&setup=true"
export * from "./TablePaginated.vue?vue&type=script&lang=ts&setup=true"

import "./TablePaginated.vue?vue&type=style&index=0&id=04534f2c&lang=scss"

const __exports__ = script;

export default __exports__